import { deleteData, getData, postData, putData } from "../Config/AxiosConfig"


export const addUsers = async (body) => {
    return await postData('user', body)
}

export const updateUser = async (id, body) => {
    return await putData(`user/${id}`, body)
}

export const deleteUser = async (id) => {
    return await deleteData(`user/${id}`)
}

export const getUsers = async () => {
    return await getData('user')
}



export const loginUser = async (body) => {
    return await postData("login", body)
} 